import { render, staticRenderFns } from "./UsersListingLeaveRequest.vue?vue&type=template&id=58e7b127&scoped=true"
import script from "./UsersListingLeaveRequest.vue?vue&type=script&lang=js"
export * from "./UsersListingLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./UsersListingLeaveRequest.vue?vue&type=style&index=0&id=58e7b127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7b127",
  null
  
)

export default component.exports